unit UJSHelper;

interface

uses JS;

type
  THTMLComponents = class
    selectedLangElement: TJSObject;
    langItems: TJSObject;
    dropdownBtn: TJSObject;

    // elements on login page
    userip: TJSObject;
    passip: TJSObject;
    loginbtn: TJSObject;
    loginTxt: TJSObject;

    // elements on Main menu page
    label1: TJSObject;
    label2: TJSObject;
    label3: TJSObject;
    label4: TJSObject;

    // elements on Hamburger menu
    hamburgerHome: TJSObject;
    hamburgerUser: TJSObject;
    hamburgerLogout: TJSObject;

    // elements on Orders menu page
    captionDate: TJSObject;
    searchBtn: TJSObject;

    // DataTable columns
    gridColumns: TJSObject;

    // elements on Orders page (container info)
    lblDate: TJSObject;
    lblSOD: TJSObject;
    lblHeader: TJSObject;
    lblDirty: TJSObject;
    lblEmptyNeeded: TJSObject;
    lblEmptyBack: TJSObject;
    lblModified: TJSObject;
    lblComment: TJSObject;
    updateBtn: TJSObject;

    // Elements on UsersMain page
    NewUserBtn: TJSObject;

    // elements on User page

    SaveUserBtn : TJSObject;

    // Elements on FIrst Login page
    SavePasswordBtn : TJSObject;

    // setting default language
    selectedLang: TJSObject;
  public
    procedure LanguageInit;
    procedure CheckLanguage;
    procedure LoginInit;
    procedure MainMenuInit;
    procedure OrdersMenuInit;
    procedure UsersMenuInit;
    procedure UserInit;
    procedure FirstLoginInit;
    procedure OrderInit;
    procedure LogisticInit;
    procedure AnalysisInit;
    procedure SetEvents;
    procedure SetLang(ALang: string);
    procedure Translations(ALang: string);
    procedure LangResize(ASize: string);
  end;

var
  HTMLComponents: THTMLComponents;

implementation

procedure THTMLComponents.LanguageInit;
begin
  {$IFDEF PAS2JS}
  asm
    // selecting the current selected language element and all language elements
    pas.UJSHelper.THTMLComponents.selectedLangElement = document.getElementsByClassName("selected");
    pas.UJSHelper.THTMLComponents.langItems = document.getElementsByClassName("wcCLLangList");

    // setting default language
    pas.UJSHelper.THTMLComponents.selectedLang = "de";
  end;
  {$ENDIF}
end;

procedure THTMLComponents.LoginInit;
begin
  {$IFDEF PAS2JS}
  asm
  // some check for Login Page?
  // take parent div and check if div snippet is empty

    // all elements on login page
    pas.UJSHelper.THTMLComponents.userip = document.getElementById("wcIDUsernameInput");
    pas.UJSHelper.THTMLComponents.passip = document.getElementById("wcIDPasswordInput");
    pas.UJSHelper.THTMLComponents.loginbtn = document.getElementById("wcIDLoginBtn");
    pas.UJSHelper.THTMLComponents.loginTxt = document.getElementById("wcIDLoginText");

  end;
  {$ENDIF}
end;


procedure THTMLComponents.LogisticInit;
begin

end;


procedure THTMLComponents.MainMenuInit;
begin
  {$IFDEF PAS2JS}
  asm
    // all elements on main menu page
    pas.UJSHelper.THTMLComponents.label1 = document.getElementById("wcIDLabel1");
    pas.UJSHelper.THTMLComponents.label2 = document.getElementById("wcIDLabel2");
    pas.UJSHelper.THTMLComponents.label3 = document.getElementById("wcIDLabel3");
    pas.UJSHelper.THTMLComponents.label4 = document.getElementById("wcIDLabel4");

    // hamburger menu items
    pas.UJSHelper.THTMLComponents.hamburgerHome = document.getElementById("wcIDHamburgerHome");
    pas.UJSHelper.THTMLComponents.hamburgerUser = document.getElementById("wcIDHamburgerUser");
    pas.UJSHelper.THTMLComponents.hamburgerLogout = document.getElementById("wcIDHamburgerLogout");
  end;
  {$ENDIF}
end;

procedure THTMLComponents.OrdersMenuInit;
begin
  {$IFDEF PAS2JS}
  asm
    pas.UJSHelper.THTMLComponents.captionDate = document.getElementById("wcIDDateLbl");
    pas.UJSHelper.THTMLComponents.searchBtn = document.getElementById("wcIDSearchBtn");
  end;
  {$ENDIF}
end;

procedure THTMLComponents.OrderInit;
begin
  {$IFDEF PAS2JS}
  asm
    // all elements on Order Page
    pas.UJSHelper.THTMLComponents.lblDate = document.getElementById("wcIDDate");
    pas.UJSHelper.THTMLComponents.lblSOD = document.getElementById("wcIDTime");
    pas.UJSHelper.THTMLComponents.lblHeader = document.getElementById("wcIDHeading");
    pas.UJSHelper.THTMLComponents.lblDirty = document.getElementById("wcIDDirty");
    pas.UJSHelper.THTMLComponents.lblEmptyNeeded = document.getElementById("wcIDEmptyContainersNeeded");
    pas.UJSHelper.THTMLComponents.lblEmptyBack = document.getElementById("wcIDEmptyContainersBack");
    pas.UJSHelper.THTMLComponents.lblModified = document.getElementById("wcIDModified");
    pas.UJSHelper.THTMLComponents.lblComment = document.getElementById("wcIDComment");
    pas.UJSHelper.THTMLComponents.updateBtn = document.getElementById("wcIDUpdateBtn");
  end;
  {$ENDIF}
end;

procedure THTMLComponents.LangResize(ASize: string);
begin
  {$IFDEF PAS2JS}
  asm
    let x = ASize;
    let cs = document.querySelector(`[data-lang="cs"]`);
    let en = document.querySelector(`[data-lang="en"]`);
    let fr = document.querySelector(`[data-lang="fr"]`);
    let de = document.querySelector(`[data-lang="de"]`);
    let nl = document.querySelector(`[data-lang="nl"]`);
    let pl = document.querySelector(`[data-lang="pl"]`);

    if (x.matches) {
      cs.innerHTML = "<img src=\"icons/flags/czech-republic.svg\" alt=\"\" width=\"40\" height=\"30\" class=\"px-1\">" + "cs";
      en.innerHTML = "<img src=\"icons/flags/united-kingdom.svg\" alt=\"\" width=\"40\" height=\"30\" class=\"px-1\">" + "en";
      fr.innerHTML = "<img src=\"icons/flags/france.svg\" alt=\"\" width=\"40\" height=\"30\" class=\"px-1\">" + "fr";
      de.innerHTML = "<img src=\"icons/flags/germany.svg\" alt=\"\" width=\"40\" height=\"30\" class=\"px-1\">" + "de";
      nl.innerHTML = "<img src=\"icons/flags/netherlands.svg\" alt=\"\" width=\"40\" height=\"30\" class=\"px-1\">" + "nl";
      pl.innerHTML = "<img src=\"icons/flags/poland.svg\" alt=\"\" width=\"40\" height=\"30\" class=\"px-1\">" + "pl";
    } else {
      cs.innerHTML = "<img src=\"icons/flags/czech-republic.svg\" alt=\"\" width=\"40\" height=\"30\" class=\"px-1\">" + "Czech";
      en.innerHTML = "<img src=\"icons/flags/united-kingdom.svg\" alt=\"\" width=\"40\" height=\"30\" class=\"px-1\">" + "english";
      fr.innerHTML = "<img src=\"icons/flags/france.svg\" alt=\"\" width=\"40\" height=\"30\" class=\"px-1\">" + "französisch";
      de.innerHTML = "<img src=\"icons/flags/germany.svg\" alt=\"\" width=\"40\" height=\"30\" class=\"px-1\">" + "deutsch";
      nl.innerHTML = "<img src=\"icons/flags/netherlands.svg\" alt=\"\" width=\"40\" height=\"30\" class=\"px-1\">" + "niederländisch";
      pl.innerHTML = "<img src=\"icons/flags/poland.svg\" alt=\"\" width=\"40\" height=\"30\" class=\"px-1\">" + "Polish";
    }
    document.getElementsByClassName("wcCLLanguageDropdown")[0].innerHTML = document.getElementsByClassName("selected")[0].innerHTML;
  end;
  {$ENDIF}
end;

procedure THTMLComponents.SetEvents;
begin
{$IFDEF PAS2JS}
  asm
  // setting events
    pas.UJSHelper.THTMLComponents.dropdownBtn = document.getElementsByClassName("wcCLLanguageDropdown");
    let dropdownCount = pas.UJSHelper.THTMLComponents.dropdownBtn.length;
    [].forEach.call(pas.UJSHelper.THTMLComponents.langItems, function (el) {
      el.addEventListener("click", (event) => {
        localStorage.setItem("language", el.dataset.lang);
        let langItemsArr = [...pas.UJSHelper.THTMLComponents.langItems];
        langItemsArr.forEach((item) => item.classList.remove("selected"));
        el.classList.add("selected");
        let i=0;
        while(i < dropdownCount )
        {
          pas.UJSHelper.THTMLComponents.dropdownBtn[i].innerHTML = el.innerHTML;
          pas.UJSHelper.THTMLComponents.selectedLang = el.dataset.lang;
          i++;
        }
        pas.UJSHelper.THTMLComponents.SetLang(pas.UJSHelper.THTMLComponents.selectedLang);
        if (document.querySelectorAll(".dt-scroll-headInner table thead tr th span.dt-column-title") != null){
            pas.UJSHelper.THTMLComponents.Translations(pas.UJSHelper.THTMLComponents.selectedLang);
        }
      });
    });
  end;
    {$ENDIF}
end;

procedure THTMLComponents.AnalysisInit;
begin

end;


procedure THTMLComponents.CheckLanguage;
begin
{$IFDEF PAS2JS}
  asm
    pas.UJSHelper.THTMLComponents.dropdownBtn = document.getElementsByClassName("wcCLLanguageDropdown");
    let dropdownCount = pas.UJSHelper.THTMLComponents.dropdownBtn.length;
// checking if language was previously selected
  if (localStorage.getItem("language") == null) {
    localStorage.setItem("language", pas.UJSHelper.THTMLComponents.selectedLangElement[0].dataset.lang);
    let i=0;
      while(i < dropdownCount)
        {
        pas.UJSHelper.THTMLComponents.dropdownBtn[i].innerHTML =
          pas.UJSHelper.THTMLComponents.selectedLangElement[0].innerHTML;
        i++;
        }

  } else {
    pas.UJSHelper.THTMLComponents.selectedLang = localStorage.getItem("language");
    pas.UJSHelper.THTMLComponents.selectedLangElement = document.querySelectorAll(
      `[data-lang="${pas.UJSHelper.THTMLComponents.selectedLang}"]`
    );
    var selectedLangElementArr = [...pas.UJSHelper.THTMLComponents.selectedLangElement];
    selectedLangElementArr.forEach((element) =>
      element.classList.remove("selected")
    );
    pas.UJSHelper.THTMLComponents.selectedLangElement[0].classList.add("selected");
    let i=0;
      while(i < dropdownCount)
        {
        pas.UJSHelper.THTMLComponents.dropdownBtn[i].innerHTML =
          pas.UJSHelper.THTMLComponents.selectedLangElement[0].innerHTML;
        i++;
        }
  }
  pas.UJSHelper.THTMLComponents.SetLang(pas.UJSHelper.THTMLComponents.selectedLang);
  end;
    {$ENDIF}
end;


procedure THTMLComponents.FirstLoginInit;
begin
  {$IFDEF PAS2JS}
  asm
    pas.UJSHelper.THTMLComponents.SavePasswordBtn = document.getElementById("wcIDSavePasswordBtn");
  end;
  {$ENDIF}
end;


procedure THTMLComponents.Translations(ALang: string);
begin
  {$IFDEF PAS2JS}
  asm
    pas.UJSHelper.THTMLComponents.gridColumns = document.querySelectorAll(".dt-scroll-headInner table thead tr th span.dt-column-title");
    let lang = ALang;
    if (pas.UJSHelper.THTMLComponents.gridColumns.length != 0){

      $.ajax({
        dataType: "json",
        url: "translations.json",
        success: function (response) {
          if (lang === "de") {
            pas.UJSHelper.THTMLComponents.gridColumns[0].innerHTML = response.de.ordersMenuPage.gridColumns.columnOrder;
            pas.UJSHelper.THTMLComponents.gridColumns[1].innerHTML = response.de.ordersMenuPage.gridColumns.columnDate;
            pas.UJSHelper.THTMLComponents.gridColumns[2].innerHTML = response.de.ordersMenuPage.gridColumns.columnSOD;
            pas.UJSHelper.THTMLComponents.gridColumns[3].innerHTML = response.de.ordersMenuPage.gridColumns.columnDirty;
            pas.UJSHelper.THTMLComponents.gridColumns[4].innerHTML = response.de.ordersMenuPage.gridColumns.columnEmptyNeeded;
            pas.UJSHelper.THTMLComponents.gridColumns[5].innerHTML = response.de.ordersMenuPage.gridColumns.columnEmptyBack;
            pas.UJSHelper.THTMLComponents.gridColumns[6].innerHTML = response.de.ordersMenuPage.gridColumns.columnComment;
          } else if (lang === "nl") {

          } else if (lang === "pl") {

          } else if (lang === "fr") {

          } else if (lang === "cs") {

          } else if (lang === "en") {
            pas.UJSHelper.THTMLComponents.gridColumns[0].innerHTML = response.en.ordersMenuPage.gridColumns.columnOrder;
            pas.UJSHelper.THTMLComponents.gridColumns[1].innerHTML = response.en.ordersMenuPage.gridColumns.columnDate;
            pas.UJSHelper.THTMLComponents.gridColumns[2].innerHTML = response.en.ordersMenuPage.gridColumns.columnSOD;
            pas.UJSHelper.THTMLComponents.gridColumns[3].innerHTML = response.en.ordersMenuPage.gridColumns.columnDirty;
            pas.UJSHelper.THTMLComponents.gridColumns[4].innerHTML = response.en.ordersMenuPage.gridColumns.columnEmptyNeeded;
            pas.UJSHelper.THTMLComponents.gridColumns[5].innerHTML = response.en.ordersMenuPage.gridColumns.columnEmptyBack;
            pas.UJSHelper.THTMLComponents.gridColumns[6].innerHTML = response.en.ordersMenuPage.gridColumns.columnComment;
          }
        },
        error: function (err) {
          console.log(err);
        },
      });
    }
  end;
  {$ENDIF}
end;


procedure THTMLComponents.UserInit;
begin
  {$IFDEF PAS2JS}
  asm
    pas.UJSHelper.THTMLComponents.SaveUserBtn = document.getElementById("wcIDSaveUserBtn");
  end;
  {$ENDIF}
end;

procedure THTMLComponents.UsersMenuInit;
begin
  {$IFDEF PAS2JS}
  asm
    pas.UJSHelper.THTMLComponents.NewUserBtn = document.getElementById("wcIDNewUserBtn");
  end;
  {$ENDIF}
end;


procedure THTMLComponents.SetLang(ALang: string);
begin
{$IFDEF PAS2JS}
  asm
    let lang = ALang;

    let loginPage = document.getElementById("wcIDLoginBtn") != null;
    let mainMenuPage = document.getElementById("wcIDLabel1") != null;
    let ordersMenuPage = document.getElementById("wcIDSearchBtn") != null;
    let ordersPage = document.getElementById("wcIDUpdateBtn") != null;

    $.ajax({
      dataType: "json",
      url: "translations.json",
      success: function (response) {
        switch (lang) {
          case "de":
            if (loginPage) {
              pas.UJSHelper.THTMLComponents.userip.placeholder =
                response.de.loginPage.username;
              pas.UJSHelper.THTMLComponents.passip.placeholder =
                response.de.loginPage.password;
              pas.UJSHelper.THTMLComponents.loginbtn.innerHTML =
                response.de.loginPage.loginBtn;
              pas.UJSHelper.THTMLComponents.loginTxt.innerHTML =
                response.de.loginPage.loginTxt;
            }
            if (mainMenuPage) {
              pas.UJSHelper.THTMLComponents.label1.innerHTML =
                response.de.mainMenuPage.captionBtn1;
              pas.UJSHelper.THTMLComponents.label2.innerHTML =
                response.de.mainMenuPage.captionBtn2;
              pas.UJSHelper.THTMLComponents.label3.innerHTML =
                response.de.mainMenuPage.captionBtn3;
              pas.UJSHelper.THTMLComponents.label4.innerHTML =
                response.de.mainMenuPage.captionBtn4;

              pas.UJSHelper.THTMLComponents.hamburgerHome.innerHTML =
                response.de.hamburgerMenu.hamburgerHome;
              pas.UJSHelper.THTMLComponents.hamburgerUser.innerHTML =
                response.de.hamburgerMenu.hamburgerUser;
              pas.UJSHelper.THTMLComponents.hamburgerLogout.innerHTML =
                response.de.hamburgerMenu.hamburgerLogout;
            }
            if (ordersMenuPage) {
              pas.UJSHelper.THTMLComponents.captionDate.innerHTML =
                response.de.ordersMenuPage.deliveryCaption;
              pas.UJSHelper.THTMLComponents.searchBtn.innerHTML =
                response.de.ordersMenuPage.searchBtn;

              pas.UJSHelper.THTMLComponents.hamburgerHome.innerHTML =
                response.de.hamburgerMenu.hamburgerHome;
              pas.UJSHelper.THTMLComponents.hamburgerUser.innerHTML =
                response.de.hamburgerMenu.hamburgerUser;
              pas.UJSHelper.THTMLComponents.hamburgerLogout.innerHTML =
                response.de.hamburgerMenu.hamburgerLogout;
            }
            if (ordersPage) {
              pas.UJSHelper.THTMLComponents.lblDate.innerHTML =
                response.de.containerInfoPage.captionDate;
              pas.UJSHelper.THTMLComponents.lblSOD.innerHTML =
                response.de.containerInfoPage.captionSOD;
              pas.UJSHelper.THTMLComponents.lblHeader.innerHTML =
                response.de.containerInfoPage.captionPageHeader;
              pas.UJSHelper.THTMLComponents.lblDirty.innerHTML =
                response.de.containerInfoPage.captionDirty;
              pas.UJSHelper.THTMLComponents.lblEmptyNeeded.innerHTML =
                response.de.containerInfoPage.captionEmptyNeeded;
              pas.UJSHelper.THTMLComponents.lblEmptyBack.innerHTML =
                response.de.containerInfoPage.captionEmptyBack;
              pas.UJSHelper.THTMLComponents.lblModified.innerHTML =
                response.de.containerInfoPage.captionModified;
              pas.UJSHelper.THTMLComponents.lblComment.innerHTML =
                response.de.containerInfoPage.captionComment;
              pas.UJSHelper.THTMLComponents.updateBtn.innerHTML =
                response.de.containerInfoPage.updateBtn;

              pas.UJSHelper.THTMLComponents.hamburgerHome.innerHTML =
                response.de.hamburgerMenu.hamburgerHome;
              pas.UJSHelper.THTMLComponents.hamburgerUser.innerHTML =
                response.de.hamburgerMenu.hamburgerUser;
              pas.UJSHelper.THTMLComponents.hamburgerLogout.innerHTML =
                response.de.hamburgerMenu.hamburgerLogout;
            }
            break;

          case "nl":
            pas.UJSHelper.THTMLComponents.userip.placeholder = response.nl.username;
            pas.UJSHelper.THTMLComponents.passip.placeholder = response.nl.password;
            pas.UJSHelper.THTMLComponents.loginbtn.innerHTML = response.nl.loginBtn;
            pas.UJSHelper.THTMLComponents.loginTxt.innerHTML = response.nl.loginTxt;
            break;
          case "pl":
            pas.UJSHelper.THTMLComponents.userip.placeholder = response.pl.username;
            pas.UJSHelper.THTMLComponents.passip.placeholder = response.pl.password;
            pas.UJSHelper.THTMLComponents.loginbtn.innerHTML = response.pl.loginBtn;
            pas.UJSHelper.THTMLComponents.loginTxt.innerHTML = response.pl.loginTxt;
            break;
          case "fr":
            pas.UJSHelper.THTMLComponents.userip.placeholder = response.fr.username;
            pas.UJSHelper.THTMLComponents.passip.placeholder = response.fr.password;
            pas.UJSHelper.THTMLComponents.loginbtn.innerHTML = response.fr.loginBtn;
            pas.UJSHelper.THTMLComponents.loginTxt.innerHTML = response.fr.loginTxt;
            break;
          case "cs":
            pas.UJSHelper.THTMLComponents.userip.placeholder = response.cs.username;
            pas.UJSHelper.THTMLComponents.passip.placeholder = response.cs.password;
            pas.UJSHelper.THTMLComponents.loginbtn.innerHTML = response.cs.loginBtn;
            pas.UJSHelper.THTMLComponents.loginTxt.innerHTML = response.cs.loginTxt;
            break;
          case "en":
            if (loginPage) {
              pas.UJSHelper.THTMLComponents.userip.placeholder =
                response.en.loginPage.username;
              pas.UJSHelper.THTMLComponents.passip.placeholder =
                response.en.loginPage.password;
              pas.UJSHelper.THTMLComponents.loginbtn.innerHTML =
                response.en.loginPage.loginBtn;
              pas.UJSHelper.THTMLComponents.loginTxt.innerHTML =
                response.en.loginPage.loginTxt;
            }
            if (mainMenuPage) {
              pas.UJSHelper.THTMLComponents.label1.innerHTML =
                response.en.mainMenuPage.captionBtn1;
              pas.UJSHelper.THTMLComponents.label2.innerHTML =
                response.en.mainMenuPage.captionBtn2;
              pas.UJSHelper.THTMLComponents.label3.innerHTML =
                response.en.mainMenuPage.captionBtn3;
              pas.UJSHelper.THTMLComponents.label4.innerHTML =
                response.en.mainMenuPage.captionBtn4;

              pas.UJSHelper.THTMLComponents.hamburgerHome.innerHTML =
                response.en.hamburgerMenu.hamburgerHome;
              pas.UJSHelper.THTMLComponents.hamburgerUser.innerHTML =
                response.en.hamburgerMenu.hamburgerUser;
              pas.UJSHelper.THTMLComponents.hamburgerLogout.innerHTML =
                response.en.hamburgerMenu.hamburgerLogout;
            }
            if (ordersMenuPage) {
              pas.UJSHelper.THTMLComponents.captionDate.innerHTML =
                response.en.ordersMenuPage.deliveryCaption;
              pas.UJSHelper.THTMLComponents.searchBtn.innerHTML =
                response.en.ordersMenuPage.searchBtn;

              pas.UJSHelper.THTMLComponents.hamburgerHome.innerHTML =
                response.en.hamburgerMenu.hamburgerHome;
              pas.UJSHelper.THTMLComponents.hamburgerUser.innerHTML =
                response.en.hamburgerMenu.hamburgerUser;
              pas.UJSHelper.THTMLComponents.hamburgerLogout.innerHTML =
                response.en.hamburgerMenu.hamburgerLogout;
            }
            if (ordersPage) {
             pas.UJSHelper.THTMLComponents.lblDate.innerHTML =
                response.en.containerInfoPage.captionDate;
              pas.UJSHelper.THTMLComponents.lblSOD.innerHTML =
                response.en.containerInfoPage.captionSOD;
              pas.UJSHelper.THTMLComponents.lblHeader.innerHTML =
                response.en.containerInfoPage.captionPageHeader;
              pas.UJSHelper.THTMLComponents.lblDirty.innerHTML =
                response.en.containerInfoPage.captionDirty;
              pas.UJSHelper.THTMLComponents.lblEmptyNeeded.innerHTML =
                response.en.containerInfoPage.captionEmptyNeeded;
              pas.UJSHelper.THTMLComponents.lblEmptyBack.innerHTML =
                response.en.containerInfoPage.captionEmptyBack;
              pas.UJSHelper.THTMLComponents.lblModified.innerHTML =
                response.en.containerInfoPage.captionModified;
              pas.UJSHelper.THTMLComponents.lblComment.innerHTML =
                response.en.containerInfoPage.captionComment;
              pas.UJSHelper.THTMLComponents.updateBtn.innerHTML =
                response.en.containerInfoPage.updateBtn;

              pas.UJSHelper.THTMLComponents.hamburgerHome.innerHTML =
                response.en.hamburgerMenu.hamburgerHome;
              pas.UJSHelper.THTMLComponents.hamburgerUser.innerHTML =
                response.en.hamburgerMenu.hamburgerUser;
              pas.UJSHelper.THTMLComponents.hamburgerLogout.innerHTML =
                response.en.hamburgerMenu.hamburgerLogout;
            }
            break;
          default:
            console.log("Langugae not available");
        }
      },
      error: function (err) {
        console.log(err);
      },
    });

  end;
    {$ENDIF}
end;

end.
